module.exports = __webpack_public_path__ + "img/celta-vigo-logo-icon.ef31ef0c.png";